<template>
  <component
    :is="as"
    :class="['star-border', customClass]"
    :style="componentStyle"
    v-bind="restAttrs"
    @click="handleClick"
  >
    <!-- 底部星芒效果 -->
    <div
      class="star-effect star-effect-bottom animate-star-movement-bottom"
      :style="{
        background: `radial-gradient(circle, ${color}, transparent 10%)`,
        animationDuration: speed
      }"
    ></div>

    <!-- 顶部星芒效果 -->
    <div
      class="star-effect star-effect-top animate-star-movement-top"
      :style="{
        background: `radial-gradient(circle, ${color}, transparent 10%)`,
        animationDuration: speed
      }"
    ></div>

    <!-- 内容容器 -->
    <div class="star-content">
      <slot />
    </div>
  </component>
</template>

<script>
export default {
  name: 'StarBorder',
  props: {
    // 渲染的标签类型（div/button/a等）
    as: {
      type: String,
      default: 'div'
    },
    // 星芒颜色
    color: {
      type: String,
      default: 'white'
    },
    // 动画速度（带单位，如6s）
    speed: {
      type: String,
      default: '6s'
    },
    // 边框厚度
    thickness: {
      type: Number,
      default: 1,
      validator: (value) => value >= 0 // 确保厚度非负
    },
    // 自定义类名
    customClass: {
      type: String,
      default: ''
    },
    // 点击事件回调
    onClick: {
      type: Function,
      default: null
    }
  },
  computed: {
    // 处理剩余属性（透传原生属性如href、target等）
    restAttrs() {
      const { as, color, speed, thickness, customClass, onClick, ...rest } = this.$attrs;
      return rest;
    },
    // 组件基础样式
    componentStyle() {
      return {
        padding: `${this.thickness}px 0`
      };
    }
  },
  methods: {
    // 处理点击事件
    handleClick(event) {
      if (this.onClick) {
        this.onClick(event);
      }
    }
  }
};
</script>

<style scoped>
/* 主组件样式 */
.star-border {
  position: relative;
  display: inline-block;
  overflow: hidden;
  background: transparent;
  border: none;
  border-radius: 20px;
}

.star-border.star-cta {
  display: block;
  border-radius: 10px;
}

.star-border.star-cta .star-content {
  padding: 0;
  border-radius: 10px;
  display: block;
  text-align: inherit;
}

/* 内容容器样式 */
.star-content {
  position: relative;
  z-index: 10;
  padding: 2px;
  text-align: center;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 星芒效果基础样式 */
.star-effect {
  position: absolute;
  width: 300%;
  height: 50%;
  opacity: 0.7;
  border-radius: 50%;
  z-index: 0;
}

/* 底部星芒定位 */
.star-effect-bottom {
  bottom: -11px;
  right: -250%;
}

/* 顶部星芒定位 */
.star-effect-top {
  top: -10px;
  left: -250%;
}

/* 底部星芒动画 */
@keyframes star-movement-bottom {
  0% {
    transform: translate(0%, 0%);
    opacity: 1;
  }
  100% {
    transform: translate(-100%, 0%);
    opacity: 0;
  }
}

/* 顶部星芒动画 */
@keyframes star-movement-top {
  0% {
    transform: translate(0%, 0%);
    opacity: 1;
  }
  100% {
    transform: translate(100%, 0%);
    opacity: 0;
  }
}

/* 动画应用类 */
.animate-star-movement-bottom {
  animation: star-movement-bottom linear infinite alternate;
}

.animate-star-movement-top {
  animation: star-movement-top linear infinite alternate;
}
</style>